(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion"] && !Shopify.designMode) return;
  try {
    /* Um só listener no documento: serve todos os acordeões da página, e os que o theme editor
     voltar a desenhar. */
  document.addEventListener('click', e => {
    const toggle = e.target.closest('[data-accordion-toggle]');
    if (!toggle) return;

    const isOpen = toggle.getAttribute('aria-expanded') === 'true';
    const group = toggle.dataset.accordionGroup;
    if (group && !isOpen) {
      document.querySelectorAll('[data-accordion-group="' + group + '"][aria-expanded="true"]')
        .forEach(other => other.setAttribute('aria-expanded', 'false'));
    }
    toggle.setAttribute('aria-expanded', String(!isOpen));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

if (typeof Shopify.getCart === 'undefined') {
  Shopify.getCart = function(callback) {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { if (typeof callback === 'function') callback(cart); });
  };
}

theme.delegate = {
    on: function(event, callback, options){
      if( !this.namespaces )
        this.namespaces = {};

      this.namespaces[event] = callback;
      options = options || false;

      this.addEventListener(event.split('.')[0], callback, options);
      return this;
    },
    off: function(event) {
      if (!this.namespaces) { return }
      this.removeEventListener(event.split('.')[0], this.namespaces[event]);
      delete this.namespaces[event];
      return this;
    }
  };

  window.on = Element.prototype.on = theme.delegate.on;
  window.off = Element.prototype.off = theme.delegate.off;

  theme.utils = {
    prepareTransition: function(el, callback) {
      el.addEventListener('transitionend', removeClass);

      function removeClass(evt) {
        el.classList.remove('is-transitioning');
        el.removeEventListener('transitionend', removeClass);
      }

      el.classList.add('is-transitioning');
      el.offsetWidth;

      if (typeof callback === 'function') {
        callback();
      }
    }
  };

  theme.a11y = {
    trapFocus: function(options) {
      const eventsName = {
        focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
        focusout: options.namespace ? 'focusout.' + options.namespace : 'focusout',
        keydown: options.namespace ? 'keydown.' + options.namespace : 'keydown.handleFocus'
      };

      const focusableEls = options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
      const elArray = [].slice.call(focusableEls);
      const focusableElements = elArray.filter(el => el.offsetParent !== null);

      const firstFocusable = focusableElements[0];
      const lastFocusable = focusableElements[focusableElements.length - 1];

      if (!options.elementToFocus) {
        options.elementToFocus = options.container;
      }

      options.container.setAttribute('tabindex', '-1');
      options.elementToFocus.focus();

      document.documentElement.off('focusin');
      document.documentElement.on(eventsName.focusout, function() {
        document.documentElement.off(eventsName.keydown);
      });

      document.documentElement.on(eventsName.focusin, function(evt) {
        if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

        document.documentElement.on(eventsName.keydown, function(evt) {
          _manageFocus(evt);
        });
      });

      function _manageFocus(evt) {
        if (evt.keyCode !== 9) return;
        if (evt.target === firstFocusable && evt.shiftKey) {
          evt.preventDefault();
          lastFocusable.focus();
        }
      }
    },

    removeTrapFocus: function(options) {
      const eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';

      if (options.container) {
        options.container.removeAttribute('tabindex');
      }

      document.documentElement.off(eventName);
    },

    lockMobileScrolling: function(namespace, element) {
      const el = element ? element : document.documentElement;
      document.documentElement.classList.add('lock-scroll');
      el.on('touchmove' + namespace, function() {
        return true;
      });
    },

    unlockMobileScrolling: function(namespace, element) {
      document.documentElement.classList.remove('lock-scroll');
      const el = element ? element : document.documentElement;
      el.off('touchmove' + namespace);
    }
  };

  theme.cart = {
    getCartProductMarkup: function() {
      let url = ''.concat(theme.routes.cartPage, '?t=').concat(Date.now());
      url = url.indexOf('?') === -1 ? (url + '?view=ajax') : (url + '&view=ajax');
      return fetch(url, { credentials: 'same-origin', method: 'GET' }).then(function(response) { return response.text() });
    },

    changeItem: function(key, qty) {
      return this._updateCart({
        url: ''.concat(theme.routes.cartChange, '?t=').concat(Date.now()),
        data: JSON.stringify({ id: key, quantity: qty })
      })
    },

    _updateCart: function(params) {
      return fetch(params.url, {
        method: 'POST',
        body: params.data,
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(response => response.json());
    }
  };

  theme.CartForm = (function() {
    const selectors = {
      products: '[data-products]',
      qtySelector: '.js-qty__wrapper',
      discounts: '[data-discounts]',
      subtotal: '[data-checkout-subtotal]',
      shipping: '.cart-shipping',
      checkoutBtn: '.cart__checkout',
      favouriteBtn: '.cart__item-favourite'
    };

    const classes = { btnLoading: 'btn--loading' };

    function CartForm(form) {
      if (!form) { return; }

      this.form = form;
      this.wrapper = form.parentNode;
      this.location = form.dataset.location;
      this.namespace = '.cart-' + this.location;
      this.products = form.querySelector(selectors.products);
      this.submitBtn = form.querySelector(selectors.checkoutBtn);
      this.discounts = form.querySelector(selectors.discounts);
      this.subtotal = form.querySelector(selectors.subtotal);

      this.init();
    }

    CartForm.prototype = Object.assign({}, CartForm.prototype, {
      init: function() {
        this.onQuantityChanged = this.quantityChanged.bind(this);
        this.initQtySelectors();
        this.initFavouriteButtons();
        document.addEventListener('cart:quantity' + this.namespace, this.onQuantityChanged);
        this.form.on('submit' + this.namespace, this.onSubmit.bind(this));
      },

      /* Para o theme editor, que volta a desenhar a página do carrinho: o formulário novo ganha um
         CartForm, e o antigo deixa de ouvir o documento. Os outros listeners vão com o markup. */
      destroy: function() {
        document.removeEventListener('cart:quantity' + this.namespace, this.onQuantityChanged);
      },

      reInit: function() {
        this.initQtySelectors();
        this.initFavouriteButtons();
      },

      /* "Move to favourites": põe o produto nos favoritos e tira a linha do carrinho. Sem sessão
         iniciada vai para /account, como o coração da PDP, e a linha fica. */
      initFavouriteButtons: function() {
        this.form.querySelectorAll(selectors.favouriteBtn).forEach(btn => {
          btn.addEventListener('click', () => {
            if (!window.theme.customerId) {
              window.location = '/account';
              return;
            }
            const handle = btn.dataset.favourite;
            if (typeof window.wishlistContains === 'function' && !window.wishlistContains(handle)) {
              window.updateWishlist(handle);
            }
            const item = btn.closest('.cart__item');
            if (item) { item.style.opacity = '0.5'; }
            this.changeQuantity(btn.dataset.key, 0);
          });
        });
      },

      onSubmit: function() {
        this.submitBtn.classList.add(classes.btnLoading);
      },

      /* O templates/cart.ajax.liquid devolve tudo o que muda com o carrinho, já renderizado — os
         preços incluídos. O JS não formata dinheiro: copia. */
      _parseProductHTML: function(html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        return {
          items: doc.querySelector('.cart__items'),
          discounts: doc.querySelector('.cart__discounts'),
          subtotal: doc.querySelector(selectors.subtotal),
          shipping: doc.querySelector(selectors.shipping)
        }
      },

      buildCart: function() {
        theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
      },

      cartMarkup: function(html) {
        const markup = this._parseProductHTML(html);
        const items = markup.items;
        const count = parseInt(items.dataset.count);

        this.updateCartDiscounts(markup.discounts);

        if (count > 0) {
          this.wrapper.classList.remove('is-empty');
        } else {
          this.wrapper.classList.add('is-empty');
        }

        this.updateCount(count);
        this.products.innerHTML = '';
        this.products.append(items);
        if (this.subtotal && markup.subtotal) this.subtotal.innerHTML = markup.subtotal.innerHTML;
        const shipping = this.form.querySelector(selectors.shipping);
        if (shipping && markup.shipping) shipping.replaceWith(markup.shipping);
        this.reInit();
      },

      updateCartDiscounts: function(markup) {
        if (!this.discounts) { return; }
        this.discounts.innerHTML = '';
        this.discounts.append(markup);
      },

      initQtySelectors: function() {
        this.form.querySelectorAll(selectors.qtySelector).forEach(el => {
          new theme.QtySelector(el, { namespace: this.namespace, isCart: true });
        });
      },

      quantityChanged: function(evt) {
        this.changeQuantity(evt.detail[0], evt.detail[1], evt.detail[2]);
      },

      /* Quantidade 0 tira a linha — é o − com 1, e o "Move to favourites". */
      changeQuantity: function(key, qty, el) {
        if (!key || typeof qty !== 'number' || qty < 0) { return; }

        if (el) { el.classList.add('is-loading'); }

        theme.cart.changeItem(key, qty)
          .then(function(cart) {
            if (cart.item_count > 0) {
              this.wrapper.classList.remove('is-empty');
            } else {
              this.wrapper.classList.add('is-empty');
            }

            Shopify.getCart(function(cart) {
              this.buildCart();
            }.bind(this));

            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          }.bind(this))
          .catch(function(err) {
            console.error('[cart] quantity update failed:', err);
          });
      },

      updateCount: function(count) {
        const countEls = document.querySelectorAll('.cart-link__bubble-num');
        if (countEls.length) {
          countEls.forEach(el => { el.innerText = count; });
        }

        /* O contador vive dentro do ícone do saco: acima de 99 não cabe, mostra-se 99+.
           O mesmo limite está no header-icons.liquid, para o primeiro render. */
        const cartCounts = document.querySelectorAll('[data-cart-count]');
        cartCounts.forEach(el => {
          el.textContent = count > 99 ? '99+' : count;
          el.classList.toggle('header-icons__cart-count--visible', count > 0);
        });

        /* O número ao lado de "Cart" — some no carrinho vazio, como no frame. */
        const drawerCount = this.form.querySelector('[data-title-count]');
        if (drawerCount) {
          drawerCount.textContent = count;
          drawerCount.hidden = count === 0;
        }
      }
    });

    return CartForm;
  })();

  theme.Drawers = (function() {
    function Drawers(id, name) {
      this.config = {
        id: id,
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + name,
        openClass: 'js-drawer-open',
        closingClass: 'js-drawer-closing',
        activeDrawer: 'cart-drawer--is-open',
        namespace: '.drawer-' + name
      };

      this.nodes = { page: document.querySelector('#MainContent') };
      this.drawer = document.querySelector('#' + id);
      this.isOpen = false;

      if (!this.drawer) { return; }

      this.init();
    }

    Drawers.prototype = Object.assign({}, Drawers.prototype, {
      init: function() {
        document.querySelectorAll(this.config.open).forEach(openBtn => {
          openBtn.setAttribute('aria-expanded', 'false');
          openBtn.addEventListener('click', this.open.bind(this));
        });

        this.drawer.querySelector(this.config.close).addEventListener('click', this.close.bind(this));

        document.addEventListener('modalOpen', function() {
          this.close();
        }.bind(this));
      },

      open: function(evt, returnFocusEl) {
        if (evt) { evt.preventDefault(); }
        if (this.isOpen) { return; }

        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          evt.currentTarget.setAttribute('aria-expanded', 'true');
          this.activeSource = evt.currentTarget;
        } else if (returnFocusEl) {
          returnFocusEl.setAttribute('aria-expanded', 'true');
          this.activeSource = returnFocusEl;
        }

        theme.utils.prepareTransition(this.drawer, function() {
          this.drawer.classList.add(this.config.activeDrawer);
        }.bind(this));

        document.documentElement.classList.add(this.config.openClass);
        this.isOpen = true;

        theme.a11y.trapFocus({ container: this.drawer, namespace: 'drawer_focus' });

        document.dispatchEvent(new CustomEvent('drawerOpen'));
        document.dispatchEvent(new CustomEvent('drawerOpen.' + this.config.id));

        this.bindEvents();
      },

      close: function(evt) {
        if (!this.isOpen) { return; }

        if (evt) {
          if (evt.target.closest('.js-drawer-close')) {
            // Do not close if using the drawer close button
          } else if (evt.target.closest('.cart-drawer')) {
            return;
          }
        }

        document.activeElement.blur();

        theme.utils.prepareTransition(this.drawer, function() {
          this.drawer.classList.remove(this.config.activeDrawer);
        }.bind(this));

        document.documentElement.classList.remove(this.config.openClass);
        document.documentElement.classList.add(this.config.closingClass);

        setTimeout(function() {
          document.documentElement.classList.remove(this.config.closingClass);
          if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
            this.activeSource.setAttribute('aria-expanded', 'false');
            this.activeSource.focus();
          }
        }.bind(this), 500);

        this.isOpen = false;

        theme.a11y.removeTrapFocus({ container: this.drawer, namespace: 'drawer_focus' });

        this.unbindEvents();
      },

      bindEvents: function() {
        window.on('click' + this.config.namespace, function(evt) {
          this.close(evt);
          return;
        }.bind(this));

        window.on('keyup' + this.config.namespace, function(evt) {
          if (evt.keyCode === 27) { this.close(); }
        }.bind(this));

        theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
      },

      unbindEvents: function() {
        window.off('click' + this.config.namespace);
        window.off('keyup' + this.config.namespace);
        theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
      }
    });

    return Drawers;
  })();

  theme.QtySelector = (function() {
    const selectors = {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus'
    };

    function QtySelector(el, options) {
      this.wrapper = el;
      this.plus = el.querySelector(selectors.plus);
      this.minus = el.querySelector(selectors.minus);
      this.input = el.querySelector(selectors.input);
      /* Sem o || 1: o carrinho usa min="0", e 0 é falsy. */
      const min = parseInt(this.input.getAttribute('min'), 10);
      this.minValue = isNaN(min) ? 1 : min;

      const defaults = { namespace: null, isCart: false, key: this.input.dataset.id };
      this.options = Object.assign({}, defaults, options);

      this.init();
    }

    QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
      init: function() {
        this.plus.addEventListener('click', function() {
          this._change(this._getQty() + 1);
        }.bind(this));

        this.minus.addEventListener('click', function() {
          this._change(this._getQty() - 1);
        }.bind(this));
      },

      _getQty: function() {
        const parsed = parseInt(this.input.value, 10);
        return isNaN(parsed) ? this.minValue : Math.max(parsed, this.minValue);
      },

      _change: function(qty) {
        if (qty < this.minValue) { qty = this.minValue; }

        const previousQty = this._getQty();
        this.input.value = qty;

        if (qty === previousQty) { return; }

        if (this.options.isCart) {
          document.dispatchEvent(new CustomEvent('cart:quantity' + this.options.namespace, {
            detail: [this.options.key, qty, this.wrapper]
          }));
        }
      }
    });

    return QtySelector;
  })();

  theme.CartDrawer = (function() {
    const selectors = { drawer: '#CartDrawer', form: '#CartDrawerForm' };

    function CartDrawer() {
      this.form = document.querySelector(selectors.form);
      this.drawer = new theme.Drawers('CartDrawer', 'cart');
      this.init();
    }

    CartDrawer.prototype = Object.assign({}, CartDrawer.prototype, {
      init: function() {
        this.cartForm = new theme.CartForm(this.form);
        this.cartForm.buildCart();

        document.addEventListener('ajaxProduct:added', function(evt) {
          this.cartForm.buildCart();
          this.open();
        }.bind(this));

        /* O "You may also like" só se pede quando o carrinho abre: quem nunca o abre não faz pedido
           nenhum. Depois é o motor que o refaz quando o carrinho muda. */
        document.addEventListener('drawerOpen.CartDrawer', function() {
          if (window.theme && typeof window.theme.loadRecommendationsIn === 'function') {
            window.theme.loadRecommendationsIn(this.form);
          }
        }.bind(this));

        document.addEventListener('cart:open', this.open.bind(this));
        document.addEventListener('cart:close', this.close.bind(this));
      },

      open: function() { this.drawer.open(); },
      close: function() { this.drawer.close(); }
    });

    return CartDrawer;
  })();

  /* Na página do carrinho o drawer não arranca: o formulário é o da página (sections/cart.liquid),
     e o saco do header fica o link para /cart. */
  if (!document.getElementById('CartPageForm')) {
    new theme.CartDrawer();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-filter-bar"] && !Shopify.designMode) return;
  try {
    let collectionFilterBarApi = null;

  function initCollectionFilterBar() {
    if (collectionFilterBarApi) collectionFilterBarApi.destroy();
    collectionFilterBarApi = null;

    const inlineBar = document.querySelector('[data-filter-bar]');
    const stickyBar = document.querySelector('[data-filter-bar-sticky]');
    if (!inlineBar || !stickyBar) return;

    /* Visível quando a barra branca saiu de vista e o footer ainda não apareceu. É o footer que
       avisa quando entra e sai do ecrã (sections/footer). */
    let inlineBarHidden = false;

    function updateStickyBar() {
      stickyBar.classList.toggle('bottom-bar--visible', inlineBarHidden && !window.theme?.footerVisible);
    }

    const inlineObserver = new IntersectionObserver(([entry]) => {
      inlineBarHidden = !entry.isIntersecting;
      updateStickyBar();
    });
    inlineObserver.observe(inlineBar);
    document.addEventListener('footer:visibility', updateStickyBar);

    collectionFilterBarApi = {
      destroy() {
        inlineObserver.disconnect();
        document.removeEventListener('footer:visibility', updateStickyBar);
        stickyBar.classList.remove('bottom-bar--visible');
      }
    };
  }

  initCollectionFilterBar();

  document.addEventListener('shopify:section:load', e => {
    if (e.target.querySelector('[data-filter-bar]')) initCollectionFilterBar();
  });
  document.addEventListener('shopify:section:unload', e => {
    if (collectionFilterBarApi && e.target.querySelector('[data-filter-bar]')) {
      collectionFilterBarApi.destroy();
      collectionFilterBarApi = null;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cookieyes"] && !Shopify.designMode) return;
  try {
    /* Um link para #cookie-preferences abre outra vez as preferências, com a função que o CookieYes
     expõe. O listener está no documento: serve o footer, o menu ou o texto de uma página. */
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href$="#cookie-preferences"]');
    if (!link || typeof window.revisitCkyConsent !== 'function') return;
    event.preventDefault();
    window.revisitCkyConsent();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["filter-drawer"] && !Shopify.designMode) return;
  try {
    /* Sem referências ao painel: os listeners estão no documento e o estado vive nas caixas do
     formulário. O painel está dentro da section da listagem, que o editor de temas volta a desenhar. */
  const FILTER_DRAWER_OPEN_CLASS = 'filter-drawer--open';
  let filterDrawerOpener = null;

  /* A linha preta do preço e os dois valores seguem os dois cursores, que não se cruzam. */
  function renderFilterDrawerPrice(drawer, moved) {
    const price = drawer.querySelector('[data-filter-price]');
    if (!price) return;
    const from = price.querySelector('[data-filter-price-from]');
    const to = price.querySelector('[data-filter-price-to]');
    if (moved === from && Number(from.value) > Number(to.value)) from.value = to.value;
    if (moved === to && Number(to.value) < Number(from.value)) to.value = from.value;
    price.style.setProperty('--filter-price-from', from.value);
    price.style.setProperty('--filter-price-to', to.value);
    price.querySelector('[data-filter-price-from-label]').textContent = price.dataset.currency + from.value;
    price.querySelector('[data-filter-price-to-label]').textContent = price.dataset.currency + to.value;
  }

  /* Abre com o que está aplicado na página: o browser repõe as caixas como o servidor as entregou. */
  function openFilterDrawer(opener) {
    const drawer = document.querySelector('[data-filter-drawer]');
    if (!drawer) return;
    filterDrawerOpener = opener;
    drawer.querySelector('[data-filter-form]').reset();
    renderFilterDrawerPrice(drawer);
    drawer.classList.add(FILTER_DRAWER_OPEN_CLASS);
    document.documentElement.classList.add('js-filter-open');
    drawer.querySelector('[data-filter-close]').focus();
  }

  function closeFilterDrawer() {
    const drawer = document.querySelector('.' + FILTER_DRAWER_OPEN_CLASS);
    if (!drawer) return;
    drawer.classList.remove(FILTER_DRAWER_OPEN_CLASS);
    document.documentElement.classList.remove('js-filter-open');
    if (filterDrawerOpener && filterDrawerOpener.isConnected) filterDrawerOpener.focus();
  }

  /* O CLEAR ALL tira as escolhas no painel, e o preço volta ao intervalo todo. */
  function clearFilterDrawer(drawer) {
    drawer.querySelectorAll('input:checked').forEach(input => { input.checked = false; });
    const from = drawer.querySelector('[data-filter-price-from]');
    const to = drawer.querySelector('[data-filter-price-to]');
    if (from) {
      from.value = from.min;
      to.value = to.max;
      renderFilterDrawerPrice(drawer);
    }
  }

  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-filter-open]');
    if (opener) {
      openFilterDrawer(opener);
      return;
    }

    const drawer = event.target.closest('[data-filter-drawer]');
    if (!drawer) return;
    if (event.target.closest('[data-filter-close]')) closeFilterDrawer();
    else if (event.target.closest('[data-filter-clear]')) clearFilterDrawer(drawer);
  });

  /* Só uma ordenação de cada vez. Um toque na escolhida tira-a, e a listagem volta à ordem dela. */
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-filter-sort]')) return;
    event.target.form.querySelectorAll('[data-filter-sort]').forEach(input => {
      if (input !== event.target) input.checked = false;
    });
  });

  document.addEventListener('input', event => {
    const drawer = event.target.closest('[data-filter-drawer]');
    if (drawer && event.target.type === 'range') renderFilterDrawerPrice(drawer, event.target);
  });

  /* O preço só entra no endereço se o intervalo foi estreitado: um cursor no seu extremo não é filtro. */
  document.addEventListener('formdata', event => {
    if (!event.target.matches('[data-filter-form]')) return;
    const from = event.target.querySelector('[data-filter-price-from]');
    const to = event.target.querySelector('[data-filter-price-to]');
    if (from && from.value === from.min) event.formData.delete(from.name);
    if (to && to.value === to.max) event.formData.delete(to.name);
  });

  /* Sem escolha nenhuma, o formulário levava a um endereço acabado em "?": vai-se ao endereço limpo. */
  document.addEventListener('submit', event => {
    if (!event.target.matches('[data-filter-form]')) return;
    if (!new FormData(event.target).keys().next().done) return;
    event.preventDefault();
    window.location.assign(window.location.pathname);
  });

  document.addEventListener('keydown', event => {
    const drawer = document.querySelector('.' + FILTER_DRAWER_OPEN_CLASS);
    if (!drawer) return;

    if (event.key === 'Escape') {
      closeFilterDrawer();
      return;
    }

    /* Com o painel aberto, o Tab dá a volta dentro dele. */
    if (event.key !== 'Tab') return;
    const fields = drawer.querySelectorAll('button, input:not([type="hidden"]):not(:disabled)');
    const first = fields[0];
    const last = fields[fields.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  /* No editor de temas a section pode sair com o painel aberto: a página não pode ficar presa. */
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.querySelector('.' + FILTER_DRAWER_OPEN_CLASS)) {
      document.documentElement.classList.remove('js-filter-open');
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["image-cover"] && !Shopify.designMode) return;
  try {
    /* O browser só escolhe a fonte de um vídeo quando o carrega. Se o ecrã passar o breakpoint depois
   disso (rodar um tablet), o vídeo que passa a estar à vista não tem fonte: manda-se escolher
   outra vez. O que fica escondido larga o que tinha descarregado. */
window.matchMedia('(min-width: 769px)').addEventListener('change', () => {
  document.querySelectorAll('.image-cover video').forEach((video) => video.load());
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["locale-selector"] && !Shopify.designMode) return;
  try {
    /* Listener delegado no document, de propósito: o selector vive em duas sections diferentes e o
     theme editor substitui o DOM delas sem reexecutar o bundle. Delegado sobrevive a isso e
     dispensa o par init/destroy que cada section teria de manter. */
  document.addEventListener('change', function (event) {
    const localeSelect = event.target.closest('[data-locale-selector]');
    if (localeSelect && localeSelect.form) localeSelect.form.submit();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["loyalty-tapcart"] && !Shopify.designMode) return;
  try {
    function loyaltyTapcartCustomerId(tapcart) {
    try {
      return tapcart.variables?.customer?.id || null;
    } catch (error) {
      return null;
    }
  }

  function openLoyaltyTapcartMemberScreen(tapcart) {
    const screen = window.theme.loyaltyTapcartScreen;
    if (!screen) return;
    try {
      tapcart.action('screen/open', { destination: { type: 'screen', id: screen } });
    } catch (error) {}
  }

  function startLoyaltyTapcart() {
    const tapcart = window.Tapcart;
    if (!tapcart || tapcart.isInitialized !== true) return;

    document.documentElement.classList.add('tapcart-app');

    document.addEventListener('click', event => {
      const cta = event.target.closest?.('.loyalty-intro__buttons a[href], a[href*="/account/login"], a[href*="/account/register"]');
      if (!cta) return;
      event.preventDefault();
      if (loyaltyTapcartCustomerId(tapcart)) {
        openLoyaltyTapcartMemberScreen(tapcart);
        return;
      }
      try {
        tapcart.actions.openAuthentication('login');
      } catch (error) {}
    });

    try {
      tapcart.registerEventHandler('customer/updated', payload => {
        if (!loyaltyTapcartCustomerId(tapcart) && !payload?.customer?.id) return;
        openLoyaltyTapcartMemberScreen(tapcart);
      });
    } catch (error) {}
  }

  if (window.Tapcart?.isInitialized === true) startLoyaltyTapcart();
  else window.addEventListener('webbridge-loaded', startLoyaltyTapcart);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["newsletter-form"] && !Shopify.designMode) return;
  try {
    // As opções do Women / Men / Both são caixas com o mesmo name, e a Omnisend deixa marcar várias.
  // Marcar uma desmarca as outras. O click() (e não checked = false) dispara o change, e a
  // Omnisend lê as caixas ao submeter: só segue a marcada.
  document.addEventListener('change', event => {
    const box = event.target;
    if (!box.checked || !box.matches('[id^="omnisend-embedded-v2-"] input[type="checkbox"][name]')) return;
    box.form.querySelectorAll(`input[type="checkbox"][name="${CSS.escape(box.name)}"]:checked`).forEach(other => {
      if (other !== box) other.click();
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-listing"] && !Shopify.designMode) return;
  try {
    /* O + e o − das duas barras (snippets/collection-filter-bar) mudam o número de colunas, com os
     cards a deslizarem para o sítio novo. */
  let productGridApi = null;

  function initProductGrid() {
    if (productGridApi) productGridApi.destroy();
    productGridApi = null;

    const grid = document.querySelector('[data-product-grid]');
    if (!grid) return;

    const btnsLess = document.querySelectorAll('[data-view-less]');
    const btnsMore = document.querySelectorAll('[data-view-more]');
    const desktop  = matchMedia('(min-width: 769px)');

    const getMin = () => desktop.matches ? 3 : 1;
    const getMax = () => desktop.matches ? 6 : 4;

    let columns = desktop.matches ? 4 : 2;

    function applyColumns() {
      grid.style.gridTemplateColumns = 'repeat(' + columns + ', 1fr)';
      btnsLess.forEach(btn => { btn.disabled = columns <= getMin(); });
      btnsMore.forEach(btn => { btn.disabled = columns >= getMax(); });
    }

    function updateGrid() {
      const cards = Array.from(grid.querySelectorAll('.product-card'));

      /* FIRST — posições e tamanhos antes da mudança */
      const firsts = cards.map(card => card.getBoundingClientRect());

      applyColumns();

      /* LAST — posições e tamanhos depois da mudança (força reflow) */
      const lasts = cards.map(card => card.getBoundingClientRect());

      /* INVERT — mover e escalar cada card de volta ao estado anterior */
      const toAnimate = [];
      cards.forEach((card, i) => {
        const dx = firsts[i].left - lasts[i].left;
        const dy = firsts[i].top - lasts[i].top;
        const sx = firsts[i].width / lasts[i].width;
        const sy = firsts[i].height / lasts[i].height;
        if (dx === 0 && dy === 0 && Math.abs(sx - 1) < 0.001 && Math.abs(sy - 1) < 0.001) return;
        card.style.transition = 'none';
        card.style.transformOrigin = '0 0';
        card.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(' + sx + ', ' + sy + ')';
        toAnimate.push(card);
      });

      if (!toAnimate.length) return;

      /* Forçar reflow */
      void grid.offsetWidth;

      /* PLAY — animar para posição e tamanho naturais */
      toAnimate.forEach(card => {
        card.style.transition = 'transform 0.35s var(--ease-drawer)';
        card.style.transform = '';
        card.addEventListener('transitionend', () => {
          card.style.transition = '';
          card.style.transformOrigin = '';
        }, { once: true });
      });
    }

    const onLess = () => { if (columns > getMin()) { columns--; updateGrid(); } };
    const onMore = () => { if (columns < getMax()) { columns++; updateGrid(); } };

    btnsLess.forEach(btn => btn.addEventListener('click', onLess));
    btnsMore.forEach(btn => btn.addEventListener('click', onMore));

    applyColumns();

    productGridApi = {
      destroy() {
        btnsLess.forEach(btn => btn.removeEventListener('click', onLess));
        btnsMore.forEach(btn => btn.removeEventListener('click', onMore));
      }
    };
  }

  initProductGrid();

  document.addEventListener('shopify:section:load', e => {
    if (e.target.querySelector('[data-product-grid]')) initProductGrid();
  });
  document.addEventListener('shopify:section:unload', e => {
    if (productGridApi && e.target.querySelector('[data-product-grid]')) {
      productGridApi.destroy();
      productGridApi = null;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-row"] && !Shopify.designMode) return;
  try {
    /* A linha de scroll vive no snippet scroll-track, que se liga sozinho pelos
   data-scroll-track-*. Esta classe trata só do fetch das recommendations —
   quando substitui os items, o MutationObserver da track recalcula. */
class ProductRow {
  constructor(el) {
    this.el = el;
    this.itemsEl = el.querySelector('[data-prow-items]');
    this._fetchRecommendations();
  }

  _fetchRecommendations() {
    if (!this.el.dataset.url) return;
    const url = `${this.el.dataset.url}?section_id=${this.el.dataset.sectionId}&product_id=${this.el.dataset.productId}&limit=8`;
    fetch(url)
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const items = doc.querySelector('[data-prow-items]');
        if (!items || !items.children.length) { this.el.hidden = true; return; }
        this.itemsEl.replaceWith(items);
        this.itemsEl = this.el.querySelector('[data-prow-items]');
      })
      .catch(err => console.error('[product-row] fetch failed', err));
  }
}

document.querySelectorAll('.product-row').forEach(el => new ProductRow(el));

/* O editor troca o HTML da section sem voltar a correr isto. */
document.addEventListener('shopify:section:load', e => {
  e.target.querySelectorAll('.product-row').forEach(el => new ProductRow(el));
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-add-bar"] && !Shopify.designMode) return;
  try {
    const quickAddBar = document.getElementById('QuickAddBar');

  if (quickAddBar) {
    const quickAddSizes  = quickAddBar.querySelector('[data-quick-add-sizes]');
    const quickAddSubmit = quickAddBar.querySelector('[data-quick-add-submit]');

    let quickAddTimer = null;

    function restartQuickAddTimer() {
      clearTimeout(quickAddTimer);
      quickAddTimer = setTimeout(closeQuickAddBar, 5000);
    }

    function openQuickAddBar(sizesTemplate) {
      quickAddSizes.replaceChildren(sizesTemplate.content.cloneNode(true));
      quickAddSizes.scrollLeft = 0;
      quickAddSubmit.disabled = true;

      quickAddBar.classList.add('bottom-bar--visible');
      quickAddSizes.querySelector('button:not(:disabled)')?.focus({ preventScroll: true });
      restartQuickAddTimer();
    }

    function closeQuickAddBar() {
      clearTimeout(quickAddTimer);
      quickAddBar.classList.remove('bottom-bar--visible');
    }

    /* O ADD TO CART fica disabled enquanto o pedido corre, e assim um segundo toque não adiciona
       outra vez. Se o pedido falha, volta a acender. */
    function addQuickAddVariant(variantId) {
      quickAddSubmit.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(r => r.json())
        .then(() => {
          closeQuickAddBar();
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        })
        .catch(err => {
          console.error('[quick-add-bar] add to cart failed', err);
          quickAddSubmit.disabled = false;
        });
    }

    function onProductCardPlus(plus) {
      const sizes = plus.closest('.product-card').querySelector('[data-quick-add-sizes]');
      if (plus.dataset.singleId) addQuickAddVariant(plus.dataset.singleId);
      else if (sizes) openQuickAddBar(sizes);
      else window.location = plus.dataset.productUrl;
    }

    /* Um toque num tamanho só o escolhe: fica sublinhado e o ADD TO CART acende. */
    quickAddSizes.addEventListener('click', e => {
      const size = e.target.closest('[data-variant-id]:not(:disabled)');
      if (!size) return;
      quickAddSizes.querySelectorAll('[aria-pressed]').forEach(b =>
        b.setAttribute('aria-pressed', String(b === size)));
      quickAddSubmit.disabled = false;
      restartQuickAddTimer();
    });

    quickAddSubmit.addEventListener('click', () => {
      const size = quickAddSizes.querySelector('[aria-pressed="true"]');
      if (size) addQuickAddVariant(size.dataset.variantId);
    });

    /* O "+" de qualquer card; um clique noutro sítio fecha a barra. */
    document.addEventListener('click', e => {
      const plus = e.target.closest('.product-card__quick-add-btn');
      if (plus) {
        onProductCardPlus(plus);
      } else if (quickAddBar.classList.contains('bottom-bar--visible') && !quickAddBar.contains(e.target)) {
        closeQuickAddBar();
      }
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && quickAddBar.classList.contains('bottom-bar--visible')) closeQuickAddBar();
    });

    /* O footer avisa quando entra no ecrã (sections/footer), e a barra fecha. */
    document.addEventListener('footer:visibility', () => {
      if (window.theme?.footerVisible) closeQuickAddBar();
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["recommendation-guide"] && !Shopify.designMode) return;
  try {
    window.theme = window.theme || {};

  const GUIDE_STORAGE_KEY = 'minga_guide';
  const GUIDE_START_KEY = 'minga_guide_start';
  const GUIDE_VIEWED_MAX_AGE = 30 * 24 * 60 * 60 * 1000;
  const GUIDE_CART_TIMEOUT = 8000;
  /* O máximo que a Shopify devolve — pedir 20 dá na mesma 10. Pede-se sempre o máximo e cada bloco
     corta ao seu limite: a folga absorve o que a section tira, e blocos com limites diferentes
     partilham o mesmo pedido. */
  const RECOMMENDATIONS_MAX = 10;
  const RECOMMENDATIONS_SECTION = 'recommendation-cards';
  const RECENTLY_VIEWED_MAX = 8;
  const RECENTLY_VIEWED_SECTION = 'recently-viewed-cards';

  const guideConfig = window.theme.recommendationGuideConfig || {};
  const guideFailedIds = new Set();
  const recommendationRequests = new Map();
  const loadedRecommendationBlocks = new Set();
  let guideState = {};
  let guidePromise = null;
  let guideCurrent;

  /* ── Memória no browser ──
     Com o armazenamento bloqueado (modo privado, bloqueadores) nada parte: o carrinho vem da
     Shopify e o guia inicial passa a ser sempre o primeiro da colecção. */
  function guideStorageGet(area, key) {
    try { return window[area].getItem(key); } catch (e) { return null; }
  }

  function guideStorageSet(area, key, value) {
    try { window[area].setItem(key, value); return true; } catch (e) { return false; }
  }

  function readGuideState() {
    try {
      guideState = Object.assign({}, guideState, JSON.parse(guideStorageGet('localStorage', GUIDE_STORAGE_KEY)));
    } catch (e) {}
    return guideState;
  }

  function saveGuideState(changes) {
    guideState = Object.assign({}, readGuideState(), changes);
    guideStorageSet('localStorage', GUIDE_STORAGE_KEY, JSON.stringify(guideState));
  }

  /* O produto aberto fica como o último visto (o guia) e entra no topo da lista dos vistos
     recentemente. A lista guarda um a mais do que mostra, porque o da própria página não se mostra. */
  if (guideConfig.currentProduct) {
    const recent = (readGuideState().recent || []).filter(id => id !== guideConfig.currentProduct.id);
    recent.unshift(guideConfig.currentProduct.id);
    saveGuideState({
      viewed: Object.assign({ at: Date.now() }, guideConfig.currentProduct),
      recent: recent.slice(0, RECENTLY_VIEWED_MAX + 1)
    });
  }

  /* ── Carrinho ── */
  function readGuideCart() {
    return new Promise((resolve, reject) => {
      if (!window.Shopify || typeof window.Shopify.getCart !== 'function') {
        reject(new Error('[recommendation-guide] Shopify.getCart indisponível'));
        return;
      }
      const timer = setTimeout(() => reject(new Error('[recommendation-guide] carrinho sem resposta')), GUIDE_CART_TIMEOUT);
      window.Shopify.getCart(cart => {
        clearTimeout(timer);
        resolve(cart);
      });
    });
  }

  /* Brindes (a linha fica a 0 pelo desconto) e gift cards não dizem nada sobre o gosto do cliente. */
  function guideCartCandidates(cart) {
    return ((cart && cart.items) || []).filter(item => !item.gift_card && item.final_line_price > 0);
  }

  function guideCartSnapshot(cart) {
    const snapshot = {};
    ((cart && cart.items) || []).forEach(item => { snapshot[item.key] = item.quantity; });
    return snapshot;
  }

  /* Os seis botões de adicionar ao carrinho do tema não dizem o que adicionaram. Compara-se o
     carrinho com a fotografia anterior: é a linha nova, ou a que ganhou quantidade.

     A Shopify põe as linhas novas no topo do cart.items (medido na loja: três adições saem pela
     ordem inversa). Mas voltar a adicionar um artigo que já lá estava só lhe aumenta a quantidade,
     sem o passar para o topo — daí a fotografia, e não só o primeiro da lista. */
  function rememberAddedCartLine(cart, before) {
    const added = guideCartCandidates(cart)
      .find(item => !(item.key in before) || item.quantity > before[item.key]);
    const changes = { snapshot: guideCartSnapshot(cart) };
    /* Se só entrou um brinde, o guia do carrinho fica como estava. */
    if (added) changes.cart = { id: added.product_id, handle: added.handle };
    saveGuideState(changes);
  }

  /* ── O guia ── */
  function guideStartIndex(length) {
    const stored = parseInt(guideStorageGet('sessionStorage', GUIDE_START_KEY), 10);
    if (stored >= 0 && stored < length) return stored;
    const picked = Math.floor(Math.random() * length);
    return guideStorageSet('sessionStorage', GUIDE_START_KEY, String(picked)) ? picked : 0;
  }

  function resolveGuideProduct(cart) {
    const state = readGuideState();

    const candidates = guideCartCandidates(cart);
    if (candidates.length) {
      const stored = state.cart && candidates.find(item => item.product_id === state.cart.id);
      const line = stored || candidates[0];
      if (!guideFailedIds.has(line.product_id)) {
        return { id: line.product_id, handle: line.handle, source: 'cart' };
      }
    }

    const viewed = state.viewed;
    if (viewed && Date.now() - viewed.at < GUIDE_VIEWED_MAX_AGE && !guideFailedIds.has(viewed.id)) {
      return { id: viewed.id, handle: viewed.handle, source: 'viewed' };
    }

    const starts = (guideConfig.startProducts || []).filter(product => !guideFailedIds.has(product.id));
    if (!starts.length) return null;
    const start = starts[guideStartIndex(starts.length)];
    return { id: start.id, handle: start.handle, source: 'start' };
  }

  function resolveGuideFromCart(cartPromise) {
    return cartPromise
      .catch(() => null)
      .then(cart => {
        if (cart) saveGuideState({ snapshot: guideCartSnapshot(cart) });
        const guide = resolveGuideProduct(cart);
        const changed = guideCurrent !== undefined && (guide && guide.id) !== (guideCurrent && guideCurrent.id);
        guideCurrent = guide;
        if (changed) {
          document.dispatchEvent(new CustomEvent('recommendation-guide:changed', { detail: { guide } }));
        }
        return guide;
      });
  }

  function getGuideProduct() {
    if (!guidePromise) guidePromise = resolveGuideFromCart(readGuideCart());
    return guidePromise.then(guide => guide && Object.assign({}, guide));
  }

  /* Produto despublicado, ou fora do mercado para onde o cliente mudou: a Shopify responde 404.
     Esquece-se o guia e passa-se à regra seguinte. */
  function forgetGuideProduct(guide) {
    guideFailedIds.add(guide.id);
    if (guide.source === 'viewed') saveGuideState({ viewed: null });
    if (guide.source === 'cart') saveGuideState({ cart: null });
    guidePromise = null;
  }

  /* ── Pedidos à Shopify ──
     Um só pedido por URL, partilhado por todos os blocos que o querem. Só se cancela quando
     nenhum bloco precisa dele. */
  function requestRecommendationCards(url, signal) {
    let entry = recommendationRequests.get(url);
    if (!entry) {
      const controller = new AbortController();
      entry = { controller, users: 0, settled: false };
      entry.promise = fetch(url, { cache: 'no-store', signal: controller.signal })
        .then(response => {
          if (!response.ok) {
            const error = new Error(`[recommendation-guide] ${response.status} ${url}`);
            error.status = response.status;
            throw error;
          }
          return response.text();
        })
        .then(html => new DOMParser().parseFromString(html, 'text/html'));
      const requestEntry = entry;
      requestEntry.promise.then(
        () => { requestEntry.settled = true; },
        () => { if (recommendationRequests.get(url) === requestEntry) recommendationRequests.delete(url); }
      );
      recommendationRequests.set(url, entry);
    }

    const sharedEntry = entry;
    sharedEntry.users += 1;
    signal.addEventListener('abort', () => {
      sharedEntry.users -= 1;
      if (sharedEntry.users === 0 && !sharedEntry.settled) {
        sharedEntry.controller.abort();
        if (recommendationRequests.get(url) === sharedEntry) recommendationRequests.delete(url);
      }
    }, { once: true });

    return sharedEntry.promise;
  }

  /* ── Blocos ──
     Se o bloco tiver mais do que os cards (um título, por exemplo), os cards vão para o
     [data-recommendations-items] lá de dentro. O bloco só se mostra quando há cards. */
  async function loadRecommendations(block) {
    if (!block) return;
    if (block._recommendationsController) block._recommendationsController.abort();
    const controller = new AbortController();
    block._recommendationsController = controller;
    loadedRecommendationBlocks.add(block);

    const section = block.dataset.recommendationsCards || RECOMMENDATIONS_SECTION;
    const intent = block.dataset.recommendationsIntent || 'related';
    const limit = Math.min(parseInt(block.dataset.recommendationsLimit, 10) || RECOMMENDATIONS_MAX, RECOMMENDATIONS_MAX);
    const target = block.querySelector('[data-recommendations-items]') || block;

    for (let attempt = 0; attempt < 2; attempt += 1) {
      const guide = await getGuideProduct();
      if (controller.signal.aborted) return;
      if (!guide) break;

      const url = `${guideConfig.recommendationsUrl}?section_id=${encodeURIComponent(section)}`
        + `&product_id=${guide.id}&limit=${RECOMMENDATIONS_MAX}&intent=${encodeURIComponent(intent)}`;

      try {
        const doc = await requestRecommendationCards(url, controller.signal);
        if (controller.signal.aborted) return;
        const root = doc.querySelector('[data-recommendation-cards]');
        const cards = root ? Array.from(root.children).slice(0, limit) : [];
        if (!cards.length) break;
        target.replaceChildren(...cards.map(card => document.importNode(card, true)));
        block.hidden = false;
        return;
      } catch (error) {
        if (controller.signal.aborted) return;
        if (!error.status) break;
        forgetGuideProduct(guide);
      }
    }

    block.hidden = true;
  }

  /* O carrinho mudou: a section filtra o que lá está, por isso as respostas guardadas já não
     servem, e os blocos já carregados refazem-se. */
  function onGuideCartChanged(cart) {
    recommendationRequests.clear();
    guidePromise = resolveGuideFromCart(Promise.resolve(cart));
    loadedRecommendationBlocks.forEach(block => {
      if (block.isConnected) loadRecommendations(block);
      else loadedRecommendationBlocks.delete(block);
    });
  }

  document.addEventListener('ajaxProduct:added', () => {
    /* A fotografia anterior lê-se já, antes de qualquer pedido. O carrinho abre no mesmo evento e
       também pede o carrinho: se a resposta dele chega primeiro, grava a fotografia nova, e a
       comparação já não encontrava o artigo que entrou. */
    const before = readGuideState().snapshot || {};
    readGuideCart()
      .then(cart => {
        rememberAddedCartLine(cart, before);
        onGuideCartChanged(cart);
      })
      .catch(error => console.warn(error));
  });

  document.addEventListener('cart:updated', event => {
    const cart = event.detail && event.detail.cart;
    if (cart) onGuideCartChanged(cart);
  });

  /* Para quem abre uma superfície (o carrinho, a pesquisa): carrega os blocos que ainda não carregaram.
     Os já carregados refazem-se sozinhos quando o carrinho muda; um header re-renderizado no editor
     traz blocos novos, que entram aqui na abertura seguinte. */
  function loadRecommendationsIn(root) {
    if (!root) return;
    root.querySelectorAll('[data-recommendations]').forEach(block => {
      if (!loadedRecommendationBlocks.has(block)) loadRecommendations(block);
    });
  }

  /* ── Vistos recentemente ──
     Os últimos produtos abertos, sem o da própria página. A Shopify devolve os cards de uma lista de
     ids pela pesquisa (id:1 OR id:2), o método do tema Horizon; a section põe-nos pela ordem do
     pedido. O bloco só se mostra quando há cards. */
  function loadRecentlyViewed(block) {
    const currentId = guideConfig.currentProduct && guideConfig.currentProduct.id;
    const limit = parseInt(block.dataset.recentlyViewedLimit, 10) || RECENTLY_VIEWED_MAX;
    const ids = (readGuideState().recent || []).filter(id => id !== currentId).slice(0, limit);
    if (!ids.length) return;

    const query = ids.map(id => 'id:' + id).join(' OR ');
    const url = `${guideConfig.searchUrl}?q=${encodeURIComponent(query)}&type=product`
      + `&section_id=${RECENTLY_VIEWED_SECTION}`;

    fetch(url)
      .then(response => {
        if (!response.ok) throw new Error(`[recommendation-guide] ${response.status} ${url}`);
        return response.text();
      })
      .then(html => {
        const root = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recently-viewed-cards]');
        const cards = root ? Array.from(root.children) : [];
        if (!cards.length || !block.isConnected) return;
        const target = block.querySelector('[data-recently-viewed-items]') || block;
        target.replaceChildren(...cards.map(card => document.importNode(card, true)));
        block.hidden = false;
      })
      .catch(error => console.warn(error));
  }

  function autoloadRecommendations(root) {
    root.querySelectorAll('[data-recommendations][data-recommendations-autoload]').forEach(loadRecommendations);
    root.querySelectorAll('[data-recently-viewed]').forEach(loadRecentlyViewed);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => autoloadRecommendations(document));
  } else {
    autoloadRecommendations(document);
  }

  document.addEventListener('shopify:section:load', event => autoloadRecommendations(event.target));

  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-recommendations]').forEach(block => {
      if (block._recommendationsController) block._recommendationsController.abort();
      loadedRecommendationBlocks.delete(block);
    });
  });

  window.theme.getGuideProduct = getGuideProduct;
  window.theme.loadRecommendations = loadRecommendations;
  window.theme.loadRecommendationsIn = loadRecommendationsIn;
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-track"] && !Shopify.designMode) return;
  try {
    class ScrollTrack {
  constructor(trackEl) {
    this.trackEl = trackEl;
    this.lineEl = trackEl.querySelector('[data-scroll-track-line]');
    const root = trackEl.closest('[data-scroll-track-root]');
    this.scrollEl = root && root.querySelector('[data-scroll-track-scroller]');
    if (!this.scrollEl || !this.lineEl) return;

    this.updateScrollTrack = this.updateScrollTrack.bind(this);
    this.scrollEl.addEventListener('scroll', this.updateScrollTrack, { passive: true });

    /* O tamanho do scroller muda com o viewport. */
    if (window.ResizeObserver) {
      new ResizeObserver(this.updateScrollTrack).observe(this.scrollEl);
    }

    /* O conteúdo pode ser injectado depois — a troca de [data-prow-items] no modo
       recommendations. Sem isto a medição inicial dá zero e a track fica escondida
       para sempre. */
    if (window.MutationObserver) {
      new MutationObserver(this.updateScrollTrack)
        .observe(this.scrollEl, { childList: true, subtree: true });
    }

    trackEl._scrollTrack = this;
    this.updateScrollTrack();
  }

  updateScrollTrack() {
    const maxScroll = this.scrollEl.scrollWidth - this.scrollEl.clientWidth;
    if (maxScroll <= 0) {
      this.trackEl.hidden = true;
      return;
    }
    this.trackEl.hidden = false;
    const ratio = this.scrollEl.scrollLeft / maxScroll;
    const travel = Math.max(0, this.trackEl.offsetWidth - this.lineEl.offsetWidth);
    this.lineEl.style.transform = 'translateX(' + ratio * travel + 'px)';
  }
}

window.theme = window.theme || {};
window.theme.ScrollTrack = ScrollTrack;

document.querySelectorAll('[data-scroll-track]').forEach(el => new ScrollTrack(el));

/* O editor troca o HTML da section sem voltar a correr isto. */
document.addEventListener('shopify:section:load', e => {
  e.target.querySelectorAll('[data-scroll-track]').forEach(el => new ScrollTrack(el));
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-guide-drawer"] && !Shopify.designMode) return;
  try {
    /* O guia vive dentro da section do produto, que o editor de temas volta a desenhar. Por isso não
     guarda referências a elementos: os listeners estão no documento e o estado vive no HTML. */
  const SIZE_GUIDE_OPEN_CLASS = 'size-guide-drawer--is-open';
  const SIZE_GUIDE_EVENT_PARAMS = { source: 'size_guide_drawer' };

  /* Os eventos de GA4, com os nomes do tema antigo. Só seguem quando a página tem o gtag. */
  function trackSizeGuide(name, params) {
    if (typeof gtag === 'function') gtag('event', name, params);
  }

  function showSizeGuideTab(drawer, name) {
    drawer.querySelectorAll('[data-size-guide-tab]').forEach(tab =>
      tab.setAttribute('aria-selected', String(tab.dataset.sizeGuideTab === name)));
    drawer.querySelectorAll('[data-size-guide-panel]').forEach(panel => {
      panel.hidden = panel.dataset.sizeGuidePanel !== name;
    });
    drawer.querySelectorAll('[data-size-guide-how]').forEach(how => {
      how.hidden = how.dataset.sizeGuideHow !== name;
    });
  }

  /* Um tamanho que o guia não tem fica como estava. */
  function showSizeGuideSize(drawer, sku) {
    const sizes = Array.from(drawer.querySelectorAll('[data-size-guide-size]'));
    if (!sizes.some(size => size.dataset.sizeGuideSize === sku)) return;
    sizes.forEach(size => size.setAttribute('aria-pressed', String(size.dataset.sizeGuideSize === sku)));
    drawer.querySelectorAll('[data-size-guide-values]').forEach(values => {
      values.hidden = values.dataset.sizeGuideValues !== sku;
    });
  }

  /* O tamanho do guia passa a ser o da página: é ela que sabe o preço, a disponibilidade e o que o
     botão diz. */
  function selectSizeGuidePageSize(sku) {
    const pageSize = Array.from(document.querySelectorAll('[data-pdp-size]'))
      .find(button => button.dataset.sku === sku);
    if (pageSize && pageSize.getAttribute('aria-pressed') !== 'true') pageSize.click();
  }

  function openSizeGuideDrawer() {
    const drawer = document.querySelector('[data-size-guide]');
    if (!drawer || drawer.classList.contains(SIZE_GUIDE_OPEN_CLASS)) return;

    /* Abre no tamanho que está escolhido na página. Se o guia não o tiver, é a página que passa para
       o do guia: o tamanho à vista aqui é sempre o que o botão adiciona. */
    const pageSize = document.querySelector('[data-pdp-size][aria-pressed="true"]');
    if (pageSize) showSizeGuideSize(drawer, pageSize.dataset.sku);
    selectSizeGuidePageSize(drawer.querySelector('[data-size-guide-size][aria-pressed="true"]').dataset.sizeGuideSize);

    drawer.classList.add(SIZE_GUIDE_OPEN_CLASS);
    document.documentElement.classList.add('js-drawer-open');
    drawer.querySelector('[data-size-guide-close]').focus();
    trackSizeGuide('size_guide_open', SIZE_GUIDE_EVENT_PARAMS);
  }

  function closeSizeGuideDrawer() {
    const drawer = document.querySelector('.' + SIZE_GUIDE_OPEN_CLASS);
    if (!drawer) return;

    /* O foco volta a quem abriu, a não ser que já tenha saído do guia: no NOTIFY ME está no campo
       de email do popup. */
    const hadFocus = drawer.contains(document.activeElement);
    drawer.classList.remove(SIZE_GUIDE_OPEN_CLASS);
    document.documentElement.classList.remove('js-drawer-open');
    const opener = document.querySelector('[data-action="size-guide-open"]');
    if (hadFocus && opener) opener.focus();
    trackSizeGuide('size_guide_close', SIZE_GUIDE_EVENT_PARAMS);
  }

  /* Um toque fora fecha o guia. Em captura, para fechar antes de outro drawer abrir: os botões do
     header param a propagação. O clique que o próprio guia faz no tamanho da página não conta. */
  document.addEventListener('click', event => {
    const drawer = document.querySelector('.' + SIZE_GUIDE_OPEN_CLASS);
    if (!drawer || !event.isTrusted) return;
    if (drawer.contains(event.target) || event.target.closest('[data-action="size-guide-open"]')) return;
    closeSizeGuideDrawer();
  }, true);

  document.addEventListener('click', event => {
    if (event.target.closest('[data-action="size-guide-open"]')) {
      openSizeGuideDrawer();
      return;
    }

    const drawer = event.target.closest('[data-size-guide]');
    if (!drawer) return;

    if (event.target.closest('[data-size-guide-close]')) {
      closeSizeGuideDrawer();
      return;
    }

    const tab = event.target.closest('[data-size-guide-tab]');
    if (tab) {
      showSizeGuideTab(drawer, tab.dataset.sizeGuideTab);
      trackSizeGuide('size_guide_tabs_click', SIZE_GUIDE_EVENT_PARAMS);
      return;
    }

    const size = event.target.closest('[data-size-guide-size]');
    if (!size) return;
    showSizeGuideSize(drawer, size.dataset.sizeGuideSize);
    selectSizeGuidePageSize(size.dataset.sizeGuideSize);
    trackSizeGuide('size_guide_size_click', SIZE_GUIDE_EVENT_PARAMS);
  });

  /* O botão do guia submete o formulário do produto, e é a section do produto que adiciona ou abre
     o NOTIFY ME. Aqui o guia só sai da frente. */
  document.addEventListener('submit', event => {
    const button = event.submitter;
    if (!button || !button.matches('[data-size-guide-add]')) return;
    if (button.querySelector('[data-pdp-notify-label]').hidden) trackSizeGuide('size_guide_add_to_cart');
    closeSizeGuideDrawer();
  });

  document.addEventListener('keydown', event => {
    const drawer = document.querySelector('.' + SIZE_GUIDE_OPEN_CLASS);
    if (!drawer) return;

    if (event.key === 'Escape') {
      closeSizeGuideDrawer();
      return;
    }

    /* Com o guia aberto, o Tab dá a volta dentro dele. */
    if (event.key !== 'Tab') return;
    const buttons = drawer.querySelectorAll('button');
    const first = buttons[0];
    const last = buttons[buttons.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  /* No editor de temas a section do produto pode sair com o guia aberto: o fundo não pode ficar preso. */
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.querySelector('.' + SIZE_GUIDE_OPEN_CLASS)) {
      document.documentElement.classList.remove('js-drawer-open');
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-action"] && !Shopify.designMode) return;
  try {
    const WISHLIST_STORAGE_KEY = 'shopify-wishlist';
  const WISHLIST_TIMESTAMP_KEY = 'minga_wishlist_timestamp';
  const WISHLIST_DELIMITER = ',';

  const wishlistInitData = window.theme.wishlistData || {};
  window.theme.customerId = wishlistInitData.customerId || '';

  function wishlistStorageGet(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }

  function wishlistStorageSet(key, value) {
    try { localStorage.setItem(key, value); } catch (e) {
      console.warn('[wishlist] localStorage unavailable:', e);
    }
  }

  function wishlistStorageRemove(key) {
    try { localStorage.removeItem(key); } catch (e) {}
  }

  window.getWishlist = function () {
    const raw = wishlistStorageGet(WISHLIST_STORAGE_KEY);
    return raw ? raw.split(WISHLIST_DELIMITER).filter(Boolean) : [];
  };

  window.setWishlist = function (array) {
    const clean = [...new Set(array.filter(Boolean))];

    if (clean.length) {
      wishlistStorageSet(WISHLIST_STORAGE_KEY, clean.join(WISHLIST_DELIMITER));
    } else {
      wishlistStorageRemove(WISHLIST_STORAGE_KEY);
    }

    document.dispatchEvent(new CustomEvent('shopify-wishlist:updated', {
      detail: { wishlist: clean }
    }));

    return clean;
  };

  window.wishlistContains = function (handle) {
    return window.getWishlist().includes(handle);
  };

  window.updateWishlist = function (handle) {
    const wishlist = window.getWishlist();
    const idx = wishlist.indexOf(handle);

    if (idx === -1) {
      wishlist.push(handle);
    } else {
      wishlist.splice(idx, 1);
    }

    window.setWishlist(wishlist);

    const nowTimestamp = new Date().toISOString().substring(0, 19);
    wishlistStorageSet(WISHLIST_TIMESTAMP_KEY, nowTimestamp);

    if (window.theme.customerId) {
      fetch('/apps/wishlist-sync', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customerId: window.theme.customerId,
          handles: wishlist,
          timestamp: nowTimestamp
        })
      }).catch(err => console.warn('[wishlist] sync failed:', err));
    }

    return wishlist;
  };

  function checkAndSyncWishlist() {
    if (!window.theme.customerId) return;

    const localTimestamp = wishlistStorageGet(WISHLIST_TIMESTAMP_KEY) || '';
    const rawMetafield = wishlistInitData.rawMetafield;
    const cloudTimestamp = wishlistInitData.cloudTimestamp || '';

    let cloudWishlist = [];
    if (rawMetafield) {
      try {
        cloudWishlist = typeof rawMetafield === 'string'
          ? JSON.parse(rawMetafield)
          : rawMetafield;
      } catch (e) {
        console.warn('[wishlist] failed to parse cloud wishlist:', e);
      }
    }

    if (cloudTimestamp === '' && localTimestamp === '') return;
    if (cloudTimestamp === localTimestamp) return;

    if (cloudTimestamp > localTimestamp || (cloudTimestamp !== '' && localTimestamp === '')) {
      window.setWishlist(cloudWishlist);
      wishlistStorageSet(WISHLIST_TIMESTAMP_KEY, cloudTimestamp);
      return;
    }

    if (localTimestamp > cloudTimestamp) {
      fetch('/apps/wishlist-sync', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customerId: window.theme.customerId,
          handles: window.getWishlist(),
          timestamp: localTimestamp
        })
      }).catch(err => console.warn('[wishlist] sync failed:', err));
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(checkAndSyncWishlist, 500);
  });

  // Signal that wishlist functions are ready for other components
  window.theme.wishlistReady = true;
  document.dispatchEvent(new CustomEvent('shopify-wishlist:ready'));
  } catch(e) { console.error(e); }
})();

})();
